import React from "react";
import { ArrowRight, Star } from "lucide-react";

const PoweredTools = () => {
  return (
    <section className="py-20 lg:py-28 relative overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-4 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          <div className="relative">
            <div className="absolute -inset-10 bg-gradient-to-br from-[#1c3df5]/20 to-transparent blur-3xl rounded-full"></div>
            <img
              src="https://images.unsplash.com/photo-1579226905180-636b76d96082?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxsYXB0b3AlMjB0cmFkaW5nfGVufDB8fHx8MTc3ODg0ODIxOHww&ixlib=rb-4.1.0&q=85"
              alt="Trading platform"
              className="relative w-full rounded-2xl border border-white/10"
            />
          </div>
          <div>
            <div className="inline-block px-3 py-1 mb-5 text-xs tracking-widest font-semibold text-[#7d8eff] border border-[#7d8eff]/30 rounded-full bg-[#1c3df5]/10">
              PLATFORMS
            </div>
            <h2 className="font-display text-[36px] lg:text-[48px] leading-[1.05] font-bold text-white mb-5">
              Powerful tools.<br /> Built for serious traders.
            </h2>
            <p className="bb-text-mute text-[16px] leading-relaxed mb-8 max-w-lg">
              Advanced charting, automation, and trading on advanced platforms like MetaTrader 4 and 5, TradingView, and Northwind X.
            </p>
            <div className="grid grid-cols-2 gap-3 max-w-md mb-8">
              {["MetaTrader 4", "MetaTrader 5", "TradingView", "Northwind X"].map((p) => (
                <div
                  key={p}
                  className="px-4 py-3 rounded-xl border border-white/10 bg-white/[0.02] hover:border-[#1c3df5]/40 hover:bg-white/[0.04] transition-all text-[14px] text-white"
                >
                  {p}
                </div>
              ))}
            </div>
            <a
              href="#"
              className="inline-flex items-center gap-2 px-6 py-3 bb-blue text-white font-medium rounded-lg transition-all hover:gap-3"
            >
              Explore platforms <ArrowRight size={16} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export const TrustBar = () => {
  return (
    <section className="py-12 lg:py-16">
      <div className="max-w-[1400px] mx-auto px-4 lg:px-8">
        <div className="bb-card rounded-3xl p-8 lg:p-10">
          <div className="text-center mb-8">
            <h2 className="font-display text-[28px] lg:text-[38px] font-bold text-white mb-2">
              Trade with confidence.
            </h2>
            <p className="bb-text-mute text-[15px]">
              As a highly-rated broker, our platforms are trusted by beginners and pros alike.
            </p>
          </div>
          <div className="grid sm:grid-cols-2 gap-4 max-w-3xl mx-auto">
            <div className="flex items-center justify-between gap-4 px-6 py-5 rounded-2xl border border-white/10 bg-white/[0.02]">
              <div>
                <div className="text-[11px] uppercase tracking-wider text-white/50 mb-1">TradingView</div>
                <div className="text-white font-semibold text-lg">Very Good</div>
                <div className="text-xs text-white/45">Based on 410 reviews</div>
              </div>
              <div className="flex items-center gap-0.5 text-[#00b67a]">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={16} fill="#00b67a" strokeWidth={0} />
                ))}
              </div>
            </div>
            <div className="flex items-center justify-between gap-4 px-6 py-5 rounded-2xl border border-white/10 bg-white/[0.02]">
              <div>
                <div className="text-[11px] uppercase tracking-wider text-white/50 mb-1">Trustpilot</div>
                <div className="text-white font-semibold text-lg">TrustScore 4.6</div>
                <div className="text-xs text-white/45">Based on 3,224 reviews</div>
              </div>
              <div className="flex items-center gap-0.5 text-[#00b67a]">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={16} fill="#00b67a" strokeWidth={0} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PoweredTools;
